import React from 'react';
import * as S from './styled';
import NavigationInfo from '../NavigationInfo';
import { useDeviceType } from '../../hooks/index';

const PageContent = ({
  size = '768',
  title,
  step,
  goBack,
  children,
  bundle,
  extraCare,
  theme = 'default',
  ...others
}) => {
  const { mobile } = useDeviceType();
  return (
    <S.PageContent
      className={`autocompra-${theme}`}
      header={title || step}
      size={size}
      {...others}
    >
      {step && (
        <>
          <NavigationInfo
            currentPage={step}
            pageAmount={mobile ? 6 : 4}
            title={title}
          />
        </>
      )}

      {children}
    </S.PageContent>
  );
};
export default PageContent;
